export enum SECURITY_COLOR {
    CRITICAL = "Critical",
    MAJOR = "Major",
    MEDIUM = "Medium",
    MINOR = "Minor",
    INFORMATIONAL = "Informational",
    YELLOW = "Yellow",
    PURPLE = "Purple",
    GREEN = "Green",
    BLUE = "Blue",
    RED = "Red",
    CYAN = "Cyan",
    PINK = "Pink",
    ORANGE = "Orange"
}